(function () {
  const U = window.UIX;
  const Core = window.RB.Core;
  const APP = window.APP;
  const artStyle = U.artStyle;
  const backSvg = U.backSvg;
  const beginDrag = U.beginDrag;
  const cardTitle = U.cardTitle;
  const clickCard = U.clickCard;
  const clickLoc = U.clickLoc;
  const el = U.el;
  const esc = U.esc;
  const groupMoveDests = U.groupMoveDests;
  const groupable = U.groupable;
  const isCandidate = U.isCandidate;
  const locIsCandidate = U.locIsCandidate;
  const locKey = U.locKey;
  const pcls = U.pcls;
  const stripCls = U.stripCls;
  const viewPlayer = U.viewPlayer;

  const PAY_MARK = { exhaustRune: "payex", recycleRune: "payrec", legend: "payadd" };

  function markPay(div, state, iid) {
    const marks = U.payMarks(state, iid);
    if (!marks) return;
    div.classList.add(marks.modes.length ? "paystaged" : "paypick");
    for (const mode of marks.modes) div.classList.add(PAY_MARK[mode]);
  }

  function markStates(div, state, iid) {
    if (APP.selection === iid) div.classList.add("selected");
    if (isCandidate(iid)) div.classList.add("candidate");
    if (APP.picked.indexOf(iid) >= 0) div.classList.add("picked");
    markPay(div, state, iid);
    const p = U.groupActor(state);
    if (p === null || !U.groupOpen(state)) return;
    if (U.moveGroup(state).indexOf(iid) >= 0) {
      div.classList.add("groupsel");
    } else if (groupable(state, p, iid)) {
      div.classList.add(U.groupStrands(state, p, iid) ? "groupwarn" : "groupok");
    }
  }

  function statusText(state, iid) {
    const o = state.objs[iid];
    const c = Core.card(state, iid);
    const parts = [];
    if (o.zone === "board") parts.push(o.ready ? "Ready" : "Exhausted");
    if ((c.supertypes || []).indexOf("champion") >= 0) parts.push("Champion");
    if (c.token) parts.push("Token");
    else if (Core.isType(state, iid, "gear") && !Core.isType(state, iid, "unit")) parts.push("Gear");
    const dmg = Core.totalDamage(o);
    if (dmg) parts.push(dmg + " dmg");
    return parts.join(" · ");
  }

  function renderPlate(state, iid) {
    const o = state.objs[iid];
    const c = Core.card(state, iid);
    const div = el("div", "card uplate");
    if (!o || !c) return div;
    div.setAttribute("data-iid", iid);
    if (RB.Anim && RB.Anim.hidden[iid]) div.classList.add("prearrive");
    if (o.zone === "board" && !o.ready) div.classList.add("exhausted");
    if ((c.supertypes || []).indexOf("champion") >= 0) div.classList.add("champ");
    markStates(div, state, iid);
    const gi = U.moveGroup(state).indexOf(iid);
    if (gi >= 0) {
      const gb = el("button", "groupbadge", String(gi + 1));
      gb.title = "Remove " + (c.name || "this unit") + " from the group";
      gb.onclick = function (ev) { ev.stopPropagation(); U.toggleGroup(iid); };
      gb.onpointerdown = function (ev) { ev.stopPropagation(); };
      div.appendChild(gb);
    }
    div.title = cardTitle(state, iid);

    artStyle(div, state, iid, "full");
    const m = o.zone === "board" ? Core.effMight(state, iid) : c.might;
    if (m !== null && m !== undefined) {
      const mv = el("div", "mv", String(m));
      if (o.zone === "board" && c.might !== null && c.might !== undefined) {
        if (m > c.might) mv.classList.add("up");
        else if (m < c.might) mv.classList.add("down");
      }
      div.appendChild(mv);
    }

    const badges = el("div", "badges");
    if (o.buffs) {
      const bb = el("span", "badge buff", "BUFF" + (o.buffs > 1 ? "×" + o.buffs : ""));
      bb.title = "Has a buff (+" + o.buffs * Core.buffValue(state, o) + " Might, already counted in the number)";
      fxKey(bb, "@buff-" + iid);
      badges.appendChild(bb);
    }
    const dmg = Core.totalDamage(o);
    if (dmg) badges.appendChild(el("span", "badge dmg", "-" + dmg));
    if (o.stunned) badges.appendChild(fxKey(el("span", "badge stun", "STUN"), "@stun-" + iid));
    if (o.empowered) badges.appendChild(fxKey(el("span", "badge emp", "EMP"), "@emp-" + iid));
    const lingering = U.lingeringOn(state, iid);
    if (lingering.length) {
      const lb = el("span", "badge linger", "LATER" + (lingering.length > 1 ? "×" + lingering.length : ""));
      lb.title = lingering.map(function (f) { return f.label + " (" + U.lingerWhen(f) + ")"; }).join("\n");
      badges.appendChild(fxKey(lb, "@linger-" + iid));
    }
    if (o.designation) badges.appendChild(el("span", "badge " + (o.designation === "attacker" ? "atk" : "def"), o.designation === "attacker" ? "ATK" : "DEF"));
    if (badges.children.length) div.appendChild(badges);

    if (o.zone === "board" && Core.isType(state, iid, "unit")) {
      const SHOW = ["assault", "shield", "deflect", "tank", "backline", "ganking", "temporary", "hunt"];
      const kws = Core.keywords(state, iid);
      const chips = el("div", "kwchips");
      for (const name of SHOW) {
        if (!kws[name]) continue;
        const v = kws[name];
        const active = (name === "assault" && o.designation === "attacker") ||
          (name === "shield" && o.designation === "defender");
        chips.appendChild(el("span", "kwchip" + (active ? " active" : ""),
          name.toUpperCase() + (typeof v === "number" && v > 1 ? " " + v : "")));
      }
      if (chips.children.length) div.appendChild(chips);
    }

    if (o.zone === "board" && !o.attachedTo) {
      const equipChip = equipCostChip(state, iid);
      if (equipChip) div.appendChild(equipChip);
    }

    div.onclick = function (ev) { clickCard(iid, ev); };
    div.onpointerdown = function (ev) { beginDrag(iid, "unit", ev); };
    if (!o.attachments || !o.attachments.length) return div;

    const pair = el("div", "eqpair");
    pair.appendChild(div);
    for (const aIid of o.attachments) pair.appendChild(renderAttachment(state, aIid));
    return pair;
  }

  function costText(cost) {
    const parts = [];
    if (cost.energy) parts.push(cost.energy + "⚡");
    for (const doms of cost.pips) parts.push((doms && doms.length ? doms[0].slice(0, 1).toUpperCase() : "?"));
    if (cost.anyPower) parts.push(cost.anyPower + "✱");
    return parts.length ? parts.join(" ") : "free";
  }

  function equipAbility(state, iid) {
    const sc = RB.Scripts.forCard(state, iid);
    return sc && (sc.abilities || []).find(function (ab) { return ab.label === "Equip"; });
  }

  function equipCostChip(state, iid) {
    const eq = equipAbility(state, iid);
    if (!eq) return null;
    const c = Core.card(state, iid);
    const text = abilityCostText(RB.Play.costFromRes(eq.cost, c.domains), eq);
    const chip = el("div", "eqchip", "EQUIP " + esc(text));
    chip.title = "Equipment - activate Equip (" + text + ") to attach it to a unit you control";
    return chip;
  }

  function abilityCostText(cost, ab) {
    const parts = [];
    const res = costText(cost);
    if (res !== "free") parts.push(res);
    if (ab.exhausts) parts.push("exhaust");
    if (ab.costXp) parts.push(ab.costXp + " XP");
    if (ab.costDiscard) parts.push("discard " + (ab.costDiscardType ? "a " + ab.costDiscardType : ab.costDiscard));
    if (ab.costKillFriendly) parts.push("kill a unit");
    if (ab.costRecycleTrash) parts.push("recycle " + ab.costRecycleTrash);
    return parts.length ? parts.join(" + ") : "free";
  }

  function fxKey(e, key) {
    e.setAttribute("data-fxkey", key);
    if (RB.Anim && RB.Anim.hidden[key]) e.classList.add("prearrive");
    return e;
  }

  function renderAttachment(state, aIid) {
    const c = Core.card(state, aIid);
    const row = el("div", "card eqtab");
    row.setAttribute("data-iid", aIid);
    if (RB.Anim && RB.Anim.hidden[aIid]) row.classList.add("prearrive");
    markStates(row, state, aIid);
    artStyle(row, state, aIid, "full");
    row.title = "Equipped to " + Core.name(state, state.objs[aIid].attachedTo) + "\n" + cardTitle(state, aIid);
    row.onclick = function (ev) { ev.stopPropagation(); clickCard(aIid, ev); };
    row.onpointerdown = function (ev) { ev.stopPropagation(); };
    return row;
  }

  function costChip(state, iid, c) {
    const o = state.objs[iid];
    let eff = c.energy;
    try { eff = RB.Play.cardCost(state, iid, { controller: o ? o.owner : undefined }).energy; } catch (e) { }
    const chip = el("span", "hcost", String(eff));
    if (eff !== c.energy) {
      chip.classList.add(eff < c.energy ? "cheap" : "pricey");
      chip.title = "Costs " + eff + " right now (printed " + c.energy + ")";
    }
    return chip;
  }

  function renderHandCard(state, iid) {
    const c = Core.card(state, iid);
    const div = el("div", "card hcard");
    if (!c) return div;
    div.setAttribute("data-iid", iid);
    if (RB.Anim && RB.Anim.hidden[iid]) div.classList.add("prearrive");
    artStyle(div, state, iid, "full");
    markStates(div, state, iid);
    if (U.LEGAL && !U.LEGAL.play[iid] && !isCandidate(iid) && APP.state.pending && APP.state.pending.kind !== "mulligan") {
      div.classList.add("illegal");
    }
    div.title = cardTitle(state, iid);
    if (c.energy !== null && c.energy !== undefined) {
      div.appendChild(costChip(state, iid, c));
    }
    div.onclick = function (ev) { clickCard(iid, ev); };
    div.onpointerdown = function (ev) { beginDrag(iid, "hand", ev); };
    return div;
  }

  function renderRune(state, iid) {
    const o = state.objs[iid];
    const div = el("div", "rune" + (o.ready ? "" : " exhausted"));
    div.setAttribute("data-iid", iid);
    artStyle(div, state, iid, "rune");
    markStates(div, state, iid);
    if (RB.Anim && RB.Anim.hidden[iid]) div.classList.add("prearrive");
    div.title = cardTitle(state, iid);
    div.onclick = function (ev) { clickCard(iid, ev); };
    return div;
  }

  function poolToken(kind, restricted, title) {
    const tok = kind === "energy"
      ? el("div", "pooltoken en", "<svg viewBox='0 0 16 16' width='11' height='11' fill='#231502'><path d='M9 1L3 9h4l-1 6 7-9H8z'/></svg>")
      : el("div", "pooltoken pw " + kind);
    if (!restricted) {
      tok.title = title;
      return tok;
    }
    const wrap = el("span", "rwrap");
    wrap.title = title;
    wrap.appendChild(tok);
    return wrap;
  }

  function poolTokens(state, p, cap) {
    const pool = state.players[p].pool;
    const items = [];
    const push = function (kind, n, restricted) { if (n) items.push({ kind: kind, n: n, restricted: restricted }); };
    push("energy", pool.energy, false);
    for (const d of ["any"].concat(Core.DOMAINS)) push(d, pool.power[d], false);
    if (pool.r) {
      push("energy", pool.r.energy, true);
      for (const d of ["any"].concat(Core.DOMAINS)) push(d, pool.r.power[d], true);
    }
    const out = [];
    const floatTitle = "Floating — the pool empties at the end of the phase.";
    const rTag = pool.r ? (pool.r.tag === "spell" ? "spells" : pool.r.tag) : "";
    for (const it of items) {
      const what = it.kind === "energy" ? "1 energy" :
        it.kind === "any" ? "1 power of any domain" : "1 " + it.kind + " power";
      const title = (it.restricted ? "Restricted — pays only for " + rTag + ". " : "") + what + ". " + floatTitle;
      const shown = Math.min(it.n, cap || 6);
      for (let i = 0; i < shown; i++) out.push(poolToken(it.kind, it.restricted, title));
      if (it.n > shown) out.push(el("span", "zlabel", "×" + it.n));
    }
    return out;
  }

  function poolSection(state, p) {
    const toks = poolTokens(state, p);
    if (!toks.length) return null;
    const sec = el("div", "poolgroup");
    for (const t of toks) sec.appendChild(t);
    sec.appendChild(el("span", "zlabel", "POOL"));
    return sec;
  }

  const TINT = { player: ["#ff9a8d", "#8fc6ee"], muted: "#93a4c0", hot: "#ffb85e", gold: "#f0c46a", ok: "#46d183" };

  function tinted(color, html) {
    return "<span style='color:" + color + "'>" + html + "</span>";
  }

  function tintChip(color, html) {
    return el("span", "chip", tinted(color, html));
  }

  function playerChip(p, html) {
    return tintChip(TINT.player[p], html);
  }

  function bfChips(state, bfIid, o) {
    const bf = state.objs[bfIid];
    const chips = el("div", o.cls);
    if (bf.controller !== null) {
      chips.appendChild(playerChip(bf.controller, esc(o.name(state, bf.controller).toUpperCase()) + o.holds));
    } else {
      chips.appendChild(tintChip(TINT.muted, o.unheld));
    }
    if (state.showdown && state.showdown.bf === bfIid) {
      chips.appendChild(tintChip(TINT.hot, state.showdown.combat ? "COMBAT" : "SHOWDOWN"));
    } else if (bf.contestedBy !== null) {
      chips.appendChild(tintChip(TINT.hot, "CONTESTED"));
    }
    if (bf.scoredBy.length) chips.appendChild(tintChip(TINT.gold, o.scored));
    return chips;
  }

  function bfUnits(state, bfIid, side) {
    const iids = Core.boardObjs(state, function (o) {
      return !o.attachedTo && o.controller === side && o.loc && o.loc.t === "bf" && o.loc.iid === bfIid;
    });
    const crowd = iids.length >= 8 ? " crowd3" : iids.length >= 6 ? " crowd2" : iids.length >= 4 ? " crowd1" : "";
    return { iids: iids, crowd: crowd };
  }

  function playerName(state, p) {
    return state.players[p].name;
  }

  function renderStrip(state, p, placement) {
    const pl = state.players[p];
    const strip = el("div", "strip " + stripCls(p) + " " + placement);
    strip.setAttribute("data-anchor", "base-" + p);
    const baseLoc = { t: "base", p: p };
    if (locIsCandidate(baseLoc)) strip.classList.add("highlight", "clickable-loc");
    if (isGroupDest(state, baseLoc)) {
      strip.classList.add("clickable-loc");
      strip.classList.add("dropok");
    }
    strip.onclick = function (ev) { clickLoc(baseLoc, ev); };

    strip.appendChild(el("span", "basetab", esc(pl.name) + "'s Base"));

    const pid = el("div", "pid " + pcls(p));
    const vscore = Core.victoryScore(state);
    const vNote = vscore !== state.mode.victory ? " (base " + state.mode.victory + ", modified by a battlefield)" : "";
    const shown = RB.Anim && RB.Anim.shownPoints ? RB.Anim.shownPoints(state, p) : pl.points;
    const cry = el("div", "crystal " + pcls(p) + (shown >= vscore ? " win" : ""));
    cry.setAttribute("data-anchor", "crystal-" + p);
    cry.appendChild(el("span", null, String(shown)));
    cry.title = pl.points + " / " + vscore + " points" + vNote;
    pid.appendChild(cry);
    const idcol = el("div", null);
    idcol.appendChild(el("div", "pname", esc(pl.name) + (APP.ai[p] ? " <span class='aichip'>AI</span>" : "")));
    idcol.appendChild(el("div", "zlabel", "XP " + pl.xp + " · " + pl.points + "/" + vscore + " PTS"));
    pid.appendChild(idcol);
    strip.appendChild(pid);

    strip.appendChild(el("div", "vdiv"));

    const units = el("div", "units");
    let anyUnit = false;
    for (const iid of Core.boardObjs(state, function (o, i2) {
      return !o.attachedTo && o.loc && o.loc.t === "base" && o.loc.p === p && !Core.isType(state, i2, "rune");
    })) {
      units.appendChild(renderPlate(state, iid));
      anyUnit = true;
    }
    strip.appendChild(units);

    strip.appendChild(el("div", "vdiv"));

    const poolSec = poolSection(state, p);
    if (poolSec) {
      poolSec.setAttribute("data-anchor", "pool-" + p);
      strip.appendChild(poolSec);
      strip.appendChild(el("div", "vdiv"));
    }

    strip.appendChild(runeGroup(state, p));

    return strip;
  }

  function baseRunes(state, p) {
    return Core.boardObjs(state, function (o, i2) {
      return !o.attachedTo && o.loc && o.loc.t === "base" && o.loc.p === p && Core.isType(state, i2, "rune");
    });
  }

  function runeDeckPile(state, p) {
    const pl = state.players[p];
    const rd = el("div", "runedeckpile");
    const rdAnchor = "runedeck-" + p;
    rd.setAttribute("data-anchor", rdAnchor);
    rd.title = "Rune deck — " + pl.runeDeck.length + " rune" + (pl.runeDeck.length === 1 ? "" : "s") + " left to channel";
    const rdLayers = Math.min(3, pl.runeDeck.length);
    if (rdLayers) {
      for (let i = rdLayers - 1; i >= 0; i--) {
        const b = el("div", "cardback rdcard", i === 0 ? backSvg(11) : "");
        b.style.transform = "translate(" + (i * -2) + "px," + (i * -2) + "px)";
        rd.appendChild(b);
      }
    } else {
      rd.appendChild(el("div", "rdcard emptypile"));
    }
    rd.appendChild(el("span", "rdcount", String(pl.runeDeck.length)));
    rd.onclick = function (ev) {
      ev.stopPropagation();
      if (APP.menu && APP.menu.pile === rdAnchor) { U.closeInspector(); return; }
      APP.selection = null;
      APP.menu = { pile: rdAnchor, kind: "runedeck", player: p, title: "Runes — " + pl.name };
      U.render();
    };
    return rd;
  }

  function runeGroup(state, p) {
    const runes = baseRunes(state, p);
    const ready = runes.filter(function (i2) { return state.objs[i2].ready; });
    const spent = runes.filter(function (i2) { return !state.objs[i2].ready; });
    const rg = el("div", "runegroup");
    for (const iid of ready) rg.appendChild(renderRune(state, iid));
    if (ready.length && spent.length) rg.appendChild(el("div", "runesplit"));
    for (const iid of spent) rg.appendChild(renderRune(state, iid));
    if (!runes.length) rg.appendChild(el("span", "zlabel", "No runes"));
    if (runes.length) rg.appendChild(el("div", "runesplit"));
    rg.appendChild(runeDeckPile(state, p));
    return rg;
  }

  function renderSide(state, p, placement) {
    const pl = state.players[p];
    const side = el("div", "pside " + placement + " " + pcls(p));
    side.setAttribute("data-anchor", "side-" + p);
    const legend = pl.legendIid ? Core.card(state, pl.legendIid) : null;
    const doms = (legend && legend.domains) || [];
    side.setAttribute("style", "--d1: var(--" + (doms[0] || "order") + "); --d2: var(--" + (doms[1] || doms[0] || "order") + ");");
    if (legend && RB.art(legend)) {
      const art = el("img", "psideart");
      art.src = RB.art(legend);
      art.alt = "";
      RB.artFallback(art, legend);
      side.appendChild(art);
    }
    side.appendChild(el("div", "psidefade"));
    side.appendChild(el("div", "psidefloor"));
    side.appendChild(el("div", "psideedge"));
    if (placement === "top") {
      side.appendChild(U.renderStation(state, p, "top"));
      side.appendChild(renderStrip(state, p, "attop"));
    } else {
      side.appendChild(renderStrip(state, p, "atbot"));
      side.appendChild(U.renderStation(state, p, "bot"));
    }
    return side;
  }

  function isGroupDest(state, loc) {
    const p = U.groupActor(state);
    const g = U.moveGroup(state);
    if (p === null || !g.length) return false;
    return groupMoveDests(state, p, g).some(function (d) { return locKey(d) === locKey(loc); });
  }

  const stripReminder = RB.Text.stripReminder;

  function facedownRows(state, bfIid, me) {
    const peeking = (state.fx || []).some(function (f) { return f.k === "seeFacedown" && f.player === me; });
    const hidden = RB.Flow.hiddenAt(state, bfIid);
    const fdRows = {};
    const out = [];
    for (const fdIid of hidden) {
      const fdo = state.objs[fdIid];
      const mineFd = fdo.owner === me;
      const seen = mineFd || peeking;
      const fd = el("div", "bffd " + (mineFd ? "minefd" : "theirsfd"));

      const playableNow = mineFd && U.LEGAL && !!U.LEGAL.play[fdIid];
      if (playableNow) fd.classList.add("playable");
      const back = el("div", "cardback", backSvg(14));
      back.setAttribute("data-iid", fdIid);
      if (RB.Anim && RB.Anim.hidden[fdIid]) back.classList.add("prearrive");

      back.title = seen ? cardTitle(state, fdIid) : "A facedown card";
      fd.onclick = function (ev) { clickCard(fdIid, ev); };
      fd.appendChild(back);
      let fdLabel;
      if (!mineFd) fdLabel = esc(state.players[fdo.owner].name) + " — Hidden" + (peeking ? " (revealed to you)" : "");
      else if (playableNow) fdLabel = "Hidden — playable";
      else if (fdo.hiddenInfo && fdo.hiddenInfo.turn >= state.turn.num) fdLabel = "Hidden — usable next turn";
      else fdLabel = "Hidden — plays in reaction windows";
      fd.appendChild(el("span", "zlabel", fdLabel));
      const rowKey = mineFd ? "mine" : "theirs";
      if (!fdRows[rowKey]) {
        fdRows[rowKey] = el("div", "bffdrow " + (mineFd ? "minefdrow" : "theirsfdrow"));
        out.push(fdRows[rowKey]);
      }
      fdRows[rowKey].appendChild(fd);
    }
    return out;
  }

  function renderBattlefields(state) {
    const me = viewPlayer(state);
    const opp = Core.otherPlayer(me);
    const area = el("div", null);
    area.id = "bfarea";
    area.setAttribute("data-anchor", "table");

    const rib = el("div", null);
    rib.id = "phaseribbon";
    const phase = state.turn.phase.charAt(0).toUpperCase() + state.turn.phase.slice(1);
    rib.appendChild(el("div", "ph", "TURN " + state.turn.num + " · " + esc(phase.toUpperCase())));
    let sub = state.players[state.turn.player].name + "'s turn";
    if (state.showdown) sub = (state.showdown.combat ? "Combat" : "Showdown") + " at " + Core.name(state, state.showdown.bf);
    rib.appendChild(el("div", "sub", esc(sub)));
    area.appendChild(rib);

    area.onclick = function () { U.clickTable(); };

    for (const bfIid of state.battlefields) {
      const bf = state.objs[bfIid];
      const c = Core.card(state, bfIid);
      const div = el("div", "battlefield");
      div.setAttribute("data-anchor", "bf-" + bfIid);
      if (bf.controller !== null) div.classList.add("ctl" + bf.controller);
      if (bf.contestedBy !== null) div.classList.add("contested");
      if (state.showdown && state.showdown.bf === bfIid) {
        div.classList.add(state.showdown.combat ? "combat" : "showdown");
      }
      const loc = { t: "bf", iid: bfIid };
      if (locIsCandidate(loc)) div.classList.add("highlight");
      if (isGroupDest(state, loc)) {
        div.classList.add("clickable-loc");
        div.classList.add("dropok");
      }
      div.onclick = function (ev) { clickLoc(loc, ev); };

      const sprite = el("div", "bfsprite");
      artStyle(sprite, state, bfIid, "full", 1400);
      div.appendChild(sprite);
      div.appendChild(el("div", "bfveil"));
      div.appendChild(el("div", "bfpennant"));
      const art = el("div", "bfart");
      art.appendChild(el("div", "shade"));
      art.appendChild(el("div", "bfname", esc(c.name)));
      art.appendChild(el("div", "bftext", U.fmtText(stripReminder(c.text))));
      art.appendChild(bfChips(state, bfIid, { cls: "bfchips", name: playerName, holds: " CONTROLS", unheld: "UNCONTROLLED", scored: "SCORED THIS TURN" }));
      div.appendChild(art);

      const rows = el("div", "bfrows");
      for (const side of [opp, me]) {
        const units = bfUnits(state, bfIid, side);
        const iids = units.iids;
        const row = el("div", "bfrow s" + side + (iids.length ? "" : " empty" + side) + units.crowd);
        for (const iid of iids) row.appendChild(renderPlate(state, iid));
        rows.appendChild(row);
      }
      div.appendChild(rows);

      for (const row of facedownRows(state, bfIid, me)) div.appendChild(row);
      area.appendChild(div);
    }

    const held = RB.Anim && RB.Anim.heldItem ? RB.Anim.heldItem(state) : null;
    if (state.chain.length > (held ? 1 : 0)) {
      area.classList.add("haschain");
      area.appendChild(renderChain(state));
    }
    return area;
  }

  function seatLabel(state, p) {
    return APP.boardSkin === "arena" && U.seatName ? U.seatName(state, p) : state.players[p].name;
  }

  function renderChain(state) {
    const rail = el("div", null);
    rail.id = "chainrail";
    rail.appendChild(el("h3", null, "THE CHAIN"));
    const pd = state.pending;
    if (pd && (pd.kind === "respond" || pd.kind === "focus")) {
      rail.appendChild(playerChip(pd.player, (pd.kind === "respond" ? "PRIORITY" : "FOCUS") + " · " + esc(seatLabel(state, pd.player).toUpperCase())));
    }
    const heldTop = RB.Anim && RB.Anim.heldItem ? RB.Anim.heldItem(state) : null;
    const items = state.chain.filter(function (it) { return !heldTop || it.id !== heldTop.id; }).reverse();
    for (let i = 0; i < items.length; i++) {
      const it = items[i];
      const div = el("div", "chainitem" + (i === 0 ? " top" : ""));
      div.setAttribute("data-anchor", "chain-" + it.id);
      fxKey(div, "@chain-" + it.id);
      const srcIid = it.iid || it.source;
      const thumb = el("div", "thumb");

      const srcLive = srcIid && state.objs[srcIid];
      const itCard = srcLive ? null : (it.cardId ? RB.Setup.findCard(it.cardId) : null);
      if (srcLive && it.iid) artStyle(thumb, state, it.iid, "full");
      else if (srcLive) artStyle(thumb, state, it.source, "art");
      else if (itCard) U.artStyleCard(thumb, itCard, "full");
      else thumb.innerHTML = backSvg(14);
      div.appendChild(thumb);
      if (srcIid && state.objs[srcIid]) {
        (function (srcIid) {
          if (state.objs[srcIid].zone === "chain") div.setAttribute("data-iid", srcIid);
          div.classList.add("clicky");
          if (APP.selection === srcIid) div.classList.add("selected");
          div.title = cardTitle(state, srcIid);
          div.onclick = function (ev) { clickCard(srcIid, ev); };
        })(srcIid);
      }
      const cl = el("div", "cl");
      cl.appendChild(el("div", "cn", U.fmtText(it.label)));
      const who = seatLabel(state, it.controller);
      const stat = it.status === "finalized" ? "FINALIZED" : "PENDING";
      const scol = it.status === "finalized" ? TINT.ok : TINT.gold;
      cl.appendChild(el("div", "cs", tinted(TINT.player[it.controller], esc(who)) + " · " + tinted(scol, stat) + (i === 0 ? " · resolves first" : "")));
      if (it.abilityText) cl.appendChild(el("div", "ce", U.fmtText(it.abilityText)));
      const tgts = Core.itemTargets(it);
      if (tgts.length) {
        const row = el("div", "ct");
        row.appendChild(el("span", "ctl", "TARGET"));
        for (const t of tgts) {
          const to = state.objs[t];
          const chip = el("span", "ctname" + (to ? " " + pcls(to.controller) : ""), esc(Core.targetNames(state, [t])[0]));
          if (to) {
            (function (t) {
              chip.onmouseenter = function () { U.flashBoardCard(t, true); };
              chip.onmouseleave = function () { U.flashBoardCard(t, false); };
              chip.onclick = function (ev) { U.flashBoardCard(t, false); clickCard(t, ev); };
              chip.classList.add("clicky");
              chip.title = cardTitle(state, t);
            })(t);
          }
          row.appendChild(chip);
        }
        cl.appendChild(row);
      }
      div.appendChild(cl);
      rail.appendChild(div);
    }
    return rail;
  }

  function lingeringOn(state, iid) {
    const out = [];
    for (const f of state.fx || []) {
      if (f.k !== "delayedTrigger") continue;
      if (f.iid === iid) { out.push(f); continue; }
      const carry = f.carry || {};
      let hit = false;
      for (const b in carry) if ((carry[b] || []).indexOf(iid) >= 0) hit = true;
      if (hit) out.push(f);
    }
    return out;
  }

  const LINGER_WHEN = {
    endOfTurn: "at end of turn", beginningPhase: "next beginning phase", startOfTurn: "next turn",
    endOfCombat: "when combat ends", combatEnd: "when combat ends",
  };
  function lingerWhen(f) {
    return LINGER_WHEN[f.on] || ("when " + String(f.on || "later"));
  }

  Object.assign(U, { runeGroup: runeGroup, runeDeckPile: runeDeckPile, baseRunes: baseRunes, poolSection: poolSection, renderRune: renderRune, renderChain: renderChain, isGroupDest: isGroupDest, facedownRows: facedownRows, stripReminder: stripReminder, tintChip: tintChip, playerChip: playerChip, bfChips: bfChips, bfUnits: bfUnits, TINT: TINT, lingeringOn: lingeringOn, lingerWhen: lingerWhen, markStates: markStates, markPay: markPay, renderPlate: renderPlate, costChip: costChip, renderHandCard: renderHandCard, poolToken: poolToken, poolTokens: poolTokens, renderStrip: renderStrip, renderBattlefields: renderBattlefields, renderSide: renderSide });
})();
